import { render, staticRenderFns } from "./AlbumItem.vue?vue&type=template&id=83cdb7f0"
import script from "./AlbumItem.vue?vue&type=script&lang=js"
export * from "./AlbumItem.vue?vue&type=script&lang=js"
import style0 from "./AlbumItem.vue?vue&type=style&index=0&id=83cdb7f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports